module.exports = __webpack_public_path__ + "static/media/money.b2800b93.svg";